import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Passwort-Eingabefeld mit Sichtbarkeits-Toggle (Auge-Icon).
 * Übernimmt alle üblichen Input-Props (value, onChange, required, autoFocus, ...).
 */
export default function PasswordInput({
  value, onChange, required, autoFocus,
  minLength, autoComplete = "current-password",
  placeholder, "data-testid": testId,
  ...rest
}) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="password-input-wrapper" data-testid={testId ? `${testId}-wrapper` : undefined}>
      <input
        {...rest}
        type={visible ? "text" : "password"}
        value={value}
        onChange={onChange}
        required={required}
        autoFocus={autoFocus}
        minLength={minLength}
        autoComplete={autoComplete}
        placeholder={placeholder}
        data-testid={testId}
      />
      <button
        type="button"
        className="password-toggle"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Passwort verbergen" : "Passwort anzeigen"}
        title={visible ? "Passwort verbergen" : "Passwort anzeigen"}
        tabIndex={-1}
        data-testid={testId ? `${testId}-toggle` : undefined}
      >
        {visible ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}
